import React from 'react';

import { ReactComponent } from '../../assets/svg/device.svg';


export default () => <ReactComponent />;
